import { useMemo } from 'react';
import { Box } from '@mui/material';
import { useAddMediaDialog, useAddNewMedia, FormValues } from 'features/media/create';
import { useDeleteMedia } from 'features/media/delete';
import { useMediaList, MediaList } from 'entities/media/media-list';

import { MediaListFilter } from 'features/media/media-filter';
import { usePagingParams } from 'shared/hooks/paging-params';
import { MediaCreateDialog } from 'features/media/create';
import { useSearchParams } from 'react-router-dom';

export const MediaListTab = () => {
  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();

  const getMediaRelatedSearchParams = useMemo(() => {
    const relatedFields = ['title', 'cityId', 'mediaTypeId', 'regionId', 'countryId','hierarchy', 'withPrices', 'placement'];
    const newParams = new URLSearchParams();
    [...searchParams.entries()].forEach(([key, value]) => {
      if (relatedFields.includes(key)) {
        newParams.append(key, value);
      }
    });
    return newParams;
  }, [searchParams]);

  const collection = useMediaList(paging, getMediaRelatedSearchParams);

  const { closeDialog } = useAddMediaDialog();

  const addNewMedia = useAddNewMedia();
  const handleAddMedia = async (formValues: FormValues) => addNewMedia(formValues).then(closeDialog);

  const deleteMedia = useDeleteMedia();

  return (
    <Box mt={2}>
      <Box mb={1}>
        <MediaListFilter withNameSearch={true} />
      </Box>

      <MediaList collection={collection} paging={paging} onChangePaging={setPaging} onMediaDeleteClick={deleteMedia} />

      <MediaCreateDialog onSubmit={handleAddMedia} />
    </Box>
  );
};
